
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { ReasonCategoryModel } from './Entities.GormCrm.ReasonCategory';
import { OrderCancellationModel } from './Entities.GormCrm.OrderCancellation';
import { OrderWarningModel } from './Entities.GormCrm.OrderWarning';
import { OrderModel } from './Entities.GormCrm.Order';
import { ProductPlanModel } from './Entities.GormCrm.ProductPlan';
import { SettlementModel } from './Entities.GormCrm.Settlement';
import { ReasonType } from 'enums/ReasonType';
import { Model, ModelProperty } from 'models/Model';


export class ReasonModel extends Model<ReasonModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'name', type: 'string' },
		{ name: 'created', type: 'Date', isHidden: true },
		{ name: 'deleted', type: 'Date', isHidden: true },
		{ name: 'categoryId', type: 'string' },
		{ name: 'onHoldTypes', type: 'number' },
		{ name: 'category', type: 'ReasonCategoryModel', isHidden: true, isObject: true, new: () => { return new ReasonCategoryModel }, properties: () => { return ReasonCategoryModel.classProperties } },
		{ name: 'orderCancellations', type: 'OrderCancellationModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new OrderCancellationModel }, properties: () => { return OrderCancellationModel.classProperties } },
		{ name: 'orderWarnings', type: 'OrderWarningModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new OrderWarningModel }, properties: () => { return OrderWarningModel.classProperties } },
		{ name: 'orders', type: 'OrderModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new OrderModel }, properties: () => { return OrderModel.classProperties } },
		{ name: 'productPlans', type: 'ProductPlanModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductPlanModel }, properties: () => { return ProductPlanModel.classProperties } },
		{ name: 'settlements', type: 'SettlementModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new SettlementModel }, properties: () => { return SettlementModel.classProperties } },
		{ name: 'types', type: 'ReasonType' }
	];
	[key: string]: any;
	
	public id?: string;
	public name: string;
	public created?: Date;
	public deleted?: Date;
	public categoryId?: string;
	public onHoldTypes?: number;
	public category?: ReasonCategoryModel;
	public orderCancellations: OrderCancellationModel[];
	public orderWarnings: OrderWarningModel[];
	public orders: OrderModel[];
	public productPlans: ProductPlanModel[];
	public settlements: SettlementModel[];
	public types: ReasonType;
    
	constructor(){
		super();
		this.id = undefined;
		this.name = '';
		this.created = undefined;
		this.deleted = undefined;
		this.categoryId = undefined;
		this.onHoldTypes = undefined;
		this.category = undefined;
		this.orderCancellations = [];
		this.orderWarnings = [];
		this.orders = [];
		this.productPlans = [];
		this.settlements = [];
		this.types = 0;
		
	}
	getProperties(){
		return ReasonModel.classProperties;
	}
}

